import React, { useState, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "../../../components/UI/Customstrap/Customstrap";
import { Link } from "react-router-dom";
import GenericButton from "../../../components/UI/Button/Button";
import confirmIcon from "../../../../public/svg/ButtonIcons/right-arrow.svg";
import { Icons } from "../../../components/UI/Icon/Icon";
import { getSavedPersonInfo, getTexts } from "../../../reducers/selectors";
import style from "./WelcomeOnboarding.scss";
import { Redirect } from "react-router-dom";

export const WelcomeOnboarding = () => {
  const personInfo = useSelector(getSavedPersonInfo);
  const [redirect, setRedirect] = useState(false);
  const texts = useSelector(getTexts);

  const profileRiskString = {
    Conservative: "Conservador",
    Moderate: "Moderado",
    Aggressive: "Agresivo",
    Aggresive: "Agresivo",
  };

  const profileRiskDescriptionString = {
    Conservative: texts.notes.investor_profile_conservative,
    Moderate: texts.notes.investor_profile_moderate,
    Aggressive: texts.notes.investor_profile_aggressive,
    Aggresive: texts.notes.investor_profile_aggressive,
  };

  const handleButtonClick = () => {
    setRedirect(true);
  };
  if (redirect) {
    //return <Redirect to="/" />;
    return (window.location.href = "/");
  }

  return (
    <div className={style.welcomeDisplay}>
      <div className={style.infoContainer}>
        <div>
          <Icons.CheckInfo className={style.iconTick} />
        </div>
        <div className={style.welcomeText}>¡Listo! Recibimos tu información</div>
        <div className={style.configurationText}>
          Completaste tu configuración de perfil. 
          Estaremos analizando tu información para abrirte una cuenta en ueno Casa de Bolsa.
        </div>
        <div className={style.profileType}>
          <div>
            <strong>Tu perfil de inversión:{" "} </strong>
            {profileRiskString[personInfo.PersonProfileRiskName]}
          </div>
          <div className={style.divider}></div>
          <div className={style.profileText}>{profileRiskDescriptionString[personInfo.PersonProfileRiskName]}</div>
        </div>
      </div>
    </div>
  );
};
